export const zbLogoIcon = `
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155.89 113.75">
    <defs>
        <style>
            .cls-1{
            fill:var(--zbp-svg-primary-color, black);
            stroke:var(--zbp-svg-primary-color, black);
            stroke-width:0.14px;
            fill-rule:evenodd;
            }
        </style>
    </defs>
    <path class="cls-1"
          d="M177.07,127.75c1-1.31-3.62-5.41-4.42-6C151.2,105.37,109,104.34,79.49,108.69c-14.65,2-44.36,10-44.36,10,2.32-5.69,19.92-33.22,26-41.84C88.41,38,97.33,32.82,98.3,31a5.35,5.35,0,0,0-2.52-6.35c-2.52-1.68-43.19,5.08-59.64,12.7-12.07,5.6-12.2,8.05-9.49,11.41,3.88,4.68,7.55.56,10.07-1.49C44.08,40.3,83.51,34.1,83.51,34.1c-11,12-22.69,29-28.78,37.41C40.17,92.2,28,114.84,22.11,123.08c-2.21,3.06,1.15,10.07,10.28,5.64,5.53-2.62,29.79-9.77,44.23-12.13,28.3-4.88,73.15-4.77,92.11,8.33C170.29,125.23,175.67,129.7,177.07,127.75Z"
          transform="translate(-21.39 -18.42)"
    />
    <path class="cls-1"
          d="M174.12,88.85c6.22-24.94-42.5-28.75-42.5-28.75,9.36-5.16,16.86-7.94,33.5-20.51,4.43-3.11,14.58-14.81,8.23-18.52-11.89-6.92-53.83,2.24-53.83,2.24-.17-1.61-.25-4.42-4.68-3.71-3.3.63-5,6.25-5,6.25l-2.35,1.34a8.61,8.61,0,0,0-4.26,6.34c-.77,4.12,4.09,4.66,4.09,4.66-.86,3.7-8.28,33.72-8.28,33.72s-5.08,23.27-5.73,26c-1.69,7.22-2.57,28.35-2.31,31.18.5,3.46,6.64,3,8.56,2.95a107,107,0,0,0,42.36-10.12C151.91,117.22,170.87,101.91,174.12,88.85Zm-8-61.56c1.71,2.19-6.36,9.7-29.53,21.76-10.31,5.26-27.25,12-27.25,12s3.91-22.19,7.89-26.56C121.85,29.19,162.74,22.91,166.16,27.29Zm.2,59.9c-3.56,15.22-26.13,29.34-36.65,31.59-1.76.39-15.39,5.33-27.35,4.13-.26-4.43-.82-25.28,1.42-35.65,1.7-7.22,3.85-16.4,3.85-16.4,6.46-2.28,19.05-3.09,24.65-2.47C155.55,71,168.11,79.77,166.36,87.19Z"
          transform="translate(-21.39 -18.42)"
    />
</svg>
`;
